export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'HI-IN',
        name: 'Devanagari - INSCRIPT',
        normal: 'ॊ1234567890-ृॉौैाीूबहगदजड़ोे्िुपरकतचटॆंमनवलस,.य',
        shift: { 0: 'ऒऍॅ्रर्ज्ञत्रक्षश्र()ःऋऑऔऐआईऊभङघधझढञओएअइउफऱखथछठऎँणऩऴळशष।य़' },
        alt: {
            1: '१२३४५६७८९०',
            12: 'ॄ',
            17: 'ॣ',
            21: 'ग़',
            23: 'ज़ड़',
            29: 'ॢ',
            33: 'क़',
            35: '॒',
            37: '॓',
            39: '॔',
            44: '॰॥'
        },
        shift_alt: { 12: 'ॠ', 17: 'ॡ', 24: 'ढ़', 29: 'ऌ', 31: 'फ़', 33: 'ख़', 36: '॑', 38: 'ॐ', 45: 'ऽ' }
    })
}
